import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, Box, Paper } from '@mui/material';
import SensorsIcon from '@mui/icons-material/Sensors';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AirlineSeatReclineNormalIcon from '@mui/icons-material/AirlineSeatReclineNormal';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DoorSlidingOutlinedIcon from '@mui/icons-material/DoorSlidingOutlined';

const UserManualsMain = () => (
  <Container maxWidth="md" sx={{ py: 4 }}>
    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
      Benutzerhandbücher
    </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <SensorsIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit'
          }}
          component={RouterLink}
          to="/user_manuals/telematik"
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Telematik und EcoApp Revolution
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Handbuch zur digitalen Transformation im Busverkehr
          </Typography>
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <VerifiedUserIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit'
          }}
          component={RouterLink}
          to="/user_manuals/manual_lapid"
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            LapID App – Führerscheinkontrolle
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Informationen und Anleitung zur digitalen Führerscheinkontrolle mit der LapID App.
          </Typography>
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <AirlineSeatReclineNormalIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit'
          }}
          component={RouterLink}
          to="/user_manuals/driving_position"
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Ergonomie & Sitzposition am Lenkrad
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tipps zur richtigen Sitzhaltung und Ergonomie für Busfahrer.
          </Typography>
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <DirectionsBusIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit'
          }}
          component={RouterLink}
          to="/user_manuals/bus_stop_trainning"
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Bus Stop Training Game
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Interaktives Spiel zur richtigen Bus-Position am Haltestellenbereich.
          </Typography>
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2, bgcolor: '#e3f2fd' }}>
        <DoorSlidingOutlinedIcon color="primary" sx={{ fontSize: 40 }} />
        <Box
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'inherit'
          }}
          component={RouterLink}
          to="/user_manuals/door_system"
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Automatisches Türsystem im MAN Bus
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Anleitung und Informationen zum modernen Türsystem für Fahrgäste und Fahrer.
          </Typography>
        </Box>
      </Paper>
    </Box>
  </Container>
);

export default UserManualsMain;